(() => {

  const popup = document.querySelector('[data-contact-form-popup]');
  const show = 'show';
  const showing = 'showing';
  const hiding = 'hiding';
  let allowToogle = true;

  if(!popup) {
    return;
  }

  const backdrop = popup.querySelector('[data-contact-form-popup-backdrop]');

  if(backdrop) {
    backdrop.addEventListener('click', () => toggleShowPopup());
  }

  document
    .querySelectorAll('.contact-form-popup-trigger, [href="#contact-form-popup-trigger"]')
    .forEach((trigger) => {

      trigger.addEventListener('click', (ev) => {
        ev.preventDefault();

        toggleShowPopup();
      });

    });

  function toggleShowPopup() {

    if(!allowToogle) {
      return;
    }

    allowToogle = false;

    // popup.classList.toggle('show');

    if(!popup.classList.contains(show)){
      popup.classList.add(showing);

      setTimeout(() => {
        popup.classList.add(show);
        popup.classList.remove(showing);

        setTimeout(() => allowToogle = true, 300);
      }, 10);
    }
    else {
      popup.classList.add(hiding);
      setTimeout(() => {
        popup.classList.remove(show);
        popup.classList.remove(hiding);
        allowToogle = true;
      }, 300);
    }
  }
})();

